import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { SettingsRulesService, SettingsRulesEditorService } from '@app/services/settings/srules.service';

import { AvailableRuleItem, RuleEvent, RuleAction } from '@app/models/rules';
import * as fromRulesModel from '@app/models/rules';

// import { RuleCreator } from '../../rule-creator';
import { OneActionListItemComponent } from '@core/components/helpers/list/one-action-list-item/one-action-list-item.component';

@Component({
  selector: 'settings-rules-rule-form-actions-main',
  templateUrl: './actions-main.component.html',
  styleUrls: ['./actions-main.component.scss'],
})
export class SettingsRulesRuleFormActionsMainComponent implements OnInit , OnDestroy {

    public readonly STATUS_LOADING = 0;
	public readonly STATUS_DONE = 1;

    protected rule: RuleEvent = null;

    public actionForms: Array<fromRulesModel.AvailableRuleItemForm> = [];
    public availableActions: Array<fromRulesModel.AvailableRuleEventAction> = [];
    public currentEventActions:  Array<fromRulesModel.AvailableRuleEventAction> = [];

    public status: number = this.STATUS_LOADING;
    public event: fromRulesModel.AvailableCurrentEventConfig = null;

    private availablesSubscriptor: Subscription;
    private editingSubscriptor: Subscription;
    private actionFormSubscriptor: Subscription;
    private currentEventSubscriptor: Subscription;

    constructor(public srulesSrv: SettingsRulesService, public editorSrv: SettingsRulesEditorService){}

    ngOnInit(){

        this.actionFormSubscriptor = this.srulesSrv.selectActionsEditForms().subscribe((actionForms: fromRulesModel.AvailableRuleItemForm[] ) => {
            this.actionForms = actionForms;
            this.initView();
        });

        this.availablesSubscriptor = this.srulesSrv.selectAvailableActions().subscribe((availActions: fromRulesModel.AvailableRuleEventAction[] ) => {
            this.availableActions = availActions;
            // When actions are set and no rule actions yet (new rule)
            if(this.availableActions.length > 0 && this.rule != null && this.rule.actions.length == 0){
                this.editorSrv.addAction();
            }
            this.initView();
        });

        this.editingSubscriptor = this.srulesSrv.selectEditing().subscribe((currentRule: fromRulesModel.RuleEvent) => {
            this.rule = currentRule;
        });

        this.currentEventSubscriptor =  this.srulesSrv.selectEditingEvent().subscribe((currentEvent: fromRulesModel.AvailableCurrentEventConfig) => {
            this.event = currentEvent;
            this.initView();
        });

    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.actionFormSubscriptor.unsubscribe();
        this.editingSubscriptor.unsubscribe();
        this.availablesSubscriptor.unsubscribe();
        this.currentEventSubscriptor.unsubscribe();
    }

    initView() : void {
        if(this.event == null){
            this.status = this.STATUS_LOADING;
            return;
        }
        this.getEventActions(); 
        this.status = (this.actionForms?.length >= 0 && this.currentEventActions?.length ==  this.event.actions.length) ? this.STATUS_DONE : this.STATUS_LOADING;
    }


    addAction() {
        this.editorSrv.addAction();
    }

    removeAction(formId: string) {
        this.editorSrv.removeAction(formId);
    }

    selectAction(actionForm: fromRulesModel.AvailableRuleItemForm, actionKey: string) {
        // here we update just the key in the action to send it to the store,
        // then store & effects reducer will select the proper variables available to set in the action 
        // with the default values.
        const action = {
            ...this.rule.actions.find((a) => a.form_id == actionForm.id),
            key: actionKey
        }
        // now call the action for update action key.
        this.editorSrv.changeActionKey(action);
    }

    selectParameters(actionForm: fromRulesModel.AvailableRuleItemForm,parameters: fromRulesModel.RuleActionParameters ) {
        const action = {
            ...this.rule.actions.find((a) => a.form_id == actionForm.id),
            parameters: parameters
        }
        // now update the current action content.
        this.editorSrv.changeAction(action);
    }

    /**
     * this get the actions just for the current selected event to let component know when all had been loaded
     */
    protected getEventActions() : void {
        this.currentEventActions = (this.event === null) ? [] : this.availableActions.filter((ac)=> this.event.actions.includes(ac.key));
    }

}
